import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to force a page reload once every time the user navigates to the component.
 * Uses sessionStorage with explicit states ('pending', 'done') to prevent reload loops.
 * @returns {void}
 */
export const useForceReload = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Unique key for this specific navigation instance.
    const reloadKey = `zahoot_reload_status_${location.key}`;
    const currentStatus = sessionStorage.getItem(reloadKey);

    if (currentStatus === 'done') {
      // Reload cycle completed successfully for this navigation key.
      // Clean up the flag for this completed navigation.
      sessionStorage.removeItem(reloadKey);
      // console.log(`[useForceReload] Cycle complete for ${location.key}, flag removed.`);
    } else if (currentStatus === 'pending') {
      // This is the render cycle *after* the reload was triggered.
      // Mark the cycle as complete.
      sessionStorage.setItem(reloadKey, 'done');
      // console.log(`[useForceReload] Post-reload render for ${location.key}, marking as done.`);
    } else {
      // First render for this navigation key.
      // Set status to 'pending' *before* reloading.
      sessionStorage.setItem(reloadKey, 'pending');
      // console.log(`[useForceReload] Initial render for ${location.key}, setting pending and reloading.`);
      // Force reload the page.
      window.location.reload();
    }

  }, [location.key]); // Rerun effect only when the navigation key changes
};